import React from "react";

import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';

export interface SelectOption {
  value: string;
  label: string;
}

export type SelectAttributeParams = {
  name: string;
  label: string;
  value: string;
  options: any[];
  disabled?: boolean;
  labelField?: string;
  valueField?: string;
  onChangeCallback: (currentValue: string) => void;
}

/**
 * A floating label select component that follows Bootstrap styling
 * @param name - Unique identifier for the select element
 * @param label - Label text to display
 * @param value - Currently selected value
 * @param options - Array of options to display in the select
 * @param onChangeCallback - Function to call when selection changes
 * @param disabled - Whether the select is disabled
 * @param required - Whether the select is required
 * @returns A styled select component with floating label
 */
export const EditSelectAttribute = ({
  name,
  label,
  value,
  options,
  onChangeCallback,
  disabled = false,
  valueField = 'value',
  labelField = 'label',
}: SelectAttributeParams) => {

  const onHandleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    onChangeCallback(e.target.value);
  }

  useEffect(() => {
    if ((value === undefined || value === null || value === '') && options?.length > 0) {
      onChangeCallback(options[0][valueField]);
    }
  }, [value, options, onChangeCallback]);

  return (
    <Form.Floating className="mb-1">
      <Form.Select
        key={name}
        id={name}
        value={value}
        onChange={onHandleChange}
        disabled={disabled}
        aria-label={label}
      >
        {options?.map((option) => (
          <option key={option[valueField]} value={option[valueField]}>
            {option[labelField]}
          </option>
        ))}
      </Form.Select>
      <label htmlFor={name}>{label}</label>
    </Form.Floating>
  );
};

/*
import Form from 'react-bootstrap/Form';

export interface SelectOption {
  value: string;
  label: string;
}

export type SelectAttributeParams = {
  name: string;
  label: string;
  value: string;
  options: SelectOption[];
  disabled?: boolean;
  onChangeCallback: (currentValue: string) => void;
}

export const EditSelectAttribute = ({
  name,
  label,
  value,
  options,
  onChangeCallback,
  disabled = false,
}: SelectAttributeParams) => {

  const onHandleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    onChangeCallback(e.target.value);
  }

  if (value === '' && options.length > 0) {
    onChangeCallback(options[0].value);
  }

  return (
    <Form.Floating className="mb-3">
      <Form.Select
        key={name}
        id={name}
        value={value}
        onChange={onHandleChange}
        disabled={disabled}
        aria-label={label}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <label htmlFor={name}>{label}</label>
    </Form.Floating>
  );
};
*/